import styled from "styled-components"
import { memo } from "react"
import WhoAreWe from "./WhoAreWe"
import { device } from "../styles/stylesConfig"

const Container = styled.div`
    height: fit-content;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    z-index: 1;
    margin-top: 100px;

    @media ${device.lg} {
        margin-top: 70px;
    }

    @media ${device.md} {
        flex-direction: column;
    }
`
const ImageContainer = styled.div`
    background-color: black;
    height: fit-content;
`

const Image = styled.img`
    object-fit: contain;
    height: 100%;
`


const AboutImageComponent = () => {

    return (

        <Container>

            <ImageContainer>
                <Image className="utils__fade-in-fast-top" src={require('../images/equipo1.webp')} alt="Equipo Aluviher" />
            </ImageContainer>

            <WhoAreWe />

        </Container>

    )
}

const AboutImage = memo(AboutImageComponent);

export default AboutImage;